import { SortType } from '@/models/SortType';
import { SuiviFinancier, SuiviFinancierFull } from '@/models/SuiviFinancier';
import { TableHeader } from '@/models/TableHeader';

export interface SuiviFinancierState {
    tableHeader: TableHeader[];
    factures: SuiviFinancier[];
    facturesWithChantierId: SuiviFinancierFull[];
    siteList: number[];

    pageSuiviFinancier: number;
    nbOfPages: number;
    count: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };

    scroll: number;
    isLoading: boolean;
    xlsLoading: boolean;
    error?: Error;
    success: boolean;
    pdfLoading: boolean;

}

export const initialState: SuiviFinancierState = {
    tableHeader: [{
            label: 'facture.suivi.tableHeader.site',
            sortData: 'chantier',
            sortStatus: SortType.NONE,
            width: '19%'
        },
        {
            label: 'facture.suivi.tableHeader.reference',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '8%'
        },
        {
            label: 'facture.suivi.tableHeader.objet',
            sortData: 'objet',
            sortStatus: SortType.NONE,
            width: '26%'
        },
        {
            label: 'facture.suivi.tableHeader.type',
            sortData: 'typeIntervention',
            sortStatus: SortType.NONE,
            width: '8%'
        },
        {
            label: 'facture.suivi.tableHeader.dateRealisation',
            sortData: 'dateFinReellle',
            sortStatus: SortType.NONE,
            width: '8%'
        },
        {
            label: 'facture.suivi.tableHeader.facturee',
            sortData: 'facturee',
            sortStatus: SortType.NONE,
            width: '4%'
        },
        {
            label: 'facture.suivi.tableHeader.mainOeuvre',
            sortData: 'mainOeuvre',
            sortStatus: SortType.NONE,
            width: '9%'
        },
        {
            label: 'facture.suivi.tableHeader.pieces',
            sortData: 'pieces',
            sortStatus: SortType.NONE,
            width: '9%'
        },
        {
            label: 'facture.suivi.tableHeader.total',
            sortData: 'montantTtc',
            sortStatus: SortType.NONE,
            width: '9%'
        },
        {
            label: 'facture.suivi.tableHeader.facture',
            sortData: 'facture',
            sortStatus: SortType.INACTIVE,
            width: '6%',
            regleCle: 'facturation.telechargementPdfConditionnel',
        }],
    factures: [],
    facturesWithChantierId: [],
    sort: {
        sortData: '',
        sortStatus: SortType.NONE
    },
    pageSuiviFinancier: 0,
    nbOfPages: 0,
    count: 0,

    scroll: 0,
    isLoading: false,
    xlsLoading: false,
    success: false,
    siteList: [],
    pdfLoading: false,
};

export const state: SuiviFinancierState = {
    ...initialState,
};
